import Avatars, { AvatarType, defaultAvatar } from 'assets/avatars/Avatars';
import AppContext from 'Contexts/AppContext';
import UserContext from 'Contexts/User';
import moment from 'moment';
import React, { useContext, useEffect, useRef, useState, memo } from 'react'
import { useNavigate } from 'react-router-dom';
import { HeaderCenter, SpinDivBox } from './HeaderScroll.styles';
import HeaderProgressbar from 'Components/HeaderProgressbar';
import SpinerHeader from 'Components/SpinerHeader';
import GoldenSpinerHeader from 'Components/GoldenSpinerHeader';
import useSound from 'use-sound';
// @ts-ignore
import buttonClick from "../../assets/sounds/buttonClick.mp3";
import Countdown from 'react-countdown';
import CountUp from 'react-countup';
import {
  claimRewardSound,
  handleExtraVote,
} from "../../common/utils/SoundClick";




const HeaderScroll = () => {
  const { userInfo } = useContext(UserContext);
  const {
    setShowReward,
    headerExtraVote,
    setHeaderExtraVote,
    inOutReward,
    setInOutReward,
    setvoteNumberEnd,
    rewardExtraVote,
    showMenubar,
    avatarImage,
    getSpinData,
    megaSpinData,
    freeSpinData,
    contDownValue,
    spinAccessLimit,
    silverSpinData,
  } = useContext(AppContext);
  const navigate = useNavigate();
  const [handleSoundClick] = useSound(buttonClick);
  const [voteNumber, setVoteNumber] = useState(0);
  const prevCountRef = useRef(voteNumber);
  const MyPath = window.location.pathname;
  const [cpmValueShow, setCpmValueShow] = React.useState(0);
  const remainingReward = (userInfo?.rewardStatistics?.total || 0) - (userInfo?.rewardStatistics?.claimed || 0);

  useEffect(() => {
    setVoteNumber(
      Number(userInfo?.voteValue || 0) +
      Number(userInfo?.rewardStatistics?.extraVote || 0)
    );

    setvoteNumberEnd(Number(userInfo?.voteValue));
    prevCountRef.current = voteNumber;
  }, [
    userInfo?.voteValue,
    userInfo?.rewardStatistics?.extraVote,
    headerExtraVote?.vote,
  ]);

  useEffect(() => {
    const score = (userInfo?.voteStatistics?.score || 0) - ((userInfo?.rewardStatistics?.total || 0) * 100);
    setCpmValueShow(score)
  }, [userInfo?.voteStatistics])

  useEffect(() => {
    // Call getSpinData only once when uid becomes available
    const calledRef = (HeaderScroll as any)._getSpinDataCalledRef || { current: false };
    (HeaderScroll as any)._getSpinDataCalledRef = calledRef;

    if (userInfo?.uid && !calledRef.current) {
      getSpinData(userInfo?.uid);
      calledRef.current = true;
    }
  }, [userInfo?.uid]);

  return (
    <div className='d-flex'>

      <div
        onClick={() => {
          navigate("/profile/wallet");
        }}
        style={{
          position: "absolute",
          cursor: "pointer",
          zIndex: "1000",
          left: `${window.screen.width > 767 ? "-10px" : "0px"}`,
        }}
      >
        <Avatars
          type={((avatarImage || userInfo?.avatar) as AvatarType) || (defaultAvatar as AvatarType)}
          style={{
            width: "64px",
            height: "64px",
            boxShadow: `${userInfo?.isUserUpgraded && (userInfo?.miningPass?.expiryDate.seconds > moment().unix()) ? "1px 0px 10px 4px #ffd700" :
              userInfo?.isUserUpgraded
                ? "1px 0px 5px 2px #FAE481"
                : (userInfo?.miningPass?.expiryDate.seconds > moment().unix()) ? "0 0 12px 4px #18A2FF"
                  : "1px 0px 5px #6352E8"
              }`,
            background: `${userInfo?.isUserUpgraded && (userInfo?.miningPass?.expiryDate.seconds > moment().unix()) ? "linear-gradient(to top, #18A2FF, #FAE481)" :
              userInfo?.isUserUpgraded
                ? "#FAE481"
                : (userInfo?.miningPass?.expiryDate.seconds > moment().unix()) ? "#18A2FF"
                  : "#6352E8"
              }`,
          }}
        />
      </div>
      <HeaderCenter
        className="d-flex justify-content-between"
        style={{
          minWidth: `${window.screen.width > 767 ? "210px" : "180px"}`,
          zIndex: "999",
        }}
      >
        {!voteNumber &&
          userInfo?.rewardStatistics?.extraVote == 0 &&
          contDownValue &&
          !!new Date(contDownValue).getDate() ? (
          // @ts-ignore
          <>
            {freeSpinData?.freeSpinAvailable == 0 && megaSpinData?.megaSpinAvailable == 0 ?
              <Countdown
                date={contDownValue}
                renderer={({
                  hours,
                  minutes,
                  seconds,
                  completed,
                }) => {
                  if (completed) {
                    getSpinData(userInfo?.uid)
                    console.log("completedcompletedcompleted 222")
                  }
                  return (
                    <span
                      style={{
                        color: "#6352e8",
                        fontSize: "10px",
                        fontWeight: 500,
                        marginLeft: `${window.screen.width > 767 ? "34px" : "24px"}`,
                      }}
                      className='text-center'
                    >
                      {"Free spin in"} {" "}
                      {hours < 1 ? null : `${hours}:`}
                      {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}

                    </span>
                  );
                }}
              /> : <span
                style={{
                  paddingLeft: "3.3em",
                }}
              >
                {userInfo.voteValue == 0 ? "spin available" : ""}
              </span>}
          </>
        ) : (
          <p className="text-center"
            style={{
              marginLeft: `${window.screen.width > 767 ? "36px" : "26px"}`,
              width: "85px",
              color: "#6352E8",
              fontSize:
                window.screen.width <= 340
                  ? "0.7889em"
                  : "10px",
            }}
          >
            <span>
              {
                MyPath == "/profile/mine" &&
                  inOutReward === 2 ? (
                  <CountUp
                    useEasing={false}
                    className={"HeaderText"}
                    start={
                      voteNumber == 0 ? 0 : voteNumber || 0
                    }
                    end={
                      (voteNumber || 0) +
                      (headerExtraVote?.vote || 0)
                    }
                    duration={
                      rewardExtraVote < 10
                        ? rewardExtraVote
                        : 10
                    }
                    delay={2}
                    onStart={() => {
                    }}
                    onEnd={() => {
                      handleExtraVote.pause();

                      setInOutReward((prev: number) => {
                        // return prev == 2 ? 3 : prev
                        claimRewardSound.play();
                        return 3;
                      });
                      if (headerExtraVote != 0) {
                        setShowReward((prev: number) => {
                          return 3;
                        });
                      }

                      setHeaderExtraVote({
                        vote: 0,
                        collect: false,
                      });
                    }}
                  />
                ) : (
                  <>
                    {voteNumber == 0 ? <span style={{ fontSize: "10px" }}>{userInfo?.voteValue == 0 ? "spin available" : ""}</span> : Number(voteNumber && voteNumber)}
                  </>
                )
              }{" "}
              {voteNumber != 0 && "votes left"}
            </span>
          </p>
        )}
        <div
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          style={{ marginRight: `${window.screen.width > 767 ? "40px" : window.screen.width < 375 ? "34px" : "28px"}`, marginTop: "9px" }}
        >
          {freeSpinData?.freeSpinAvailable < 1 && (!silverSpinData?.silverSpinAvailable || silverSpinData?.silverSpinAvailable < 1) && megaSpinData?.megaSpinAvailable < 1 && voteNumber != 0 ?
            <SpinDivBox
              onClick={() => {
                navigate(`/wheel`)
                handleSoundClick();
              }}
            >
              {userInfo?.voteValue >= spinAccessLimit ? <GoldenSpinerHeader /> : <>
                {Object.keys(freeSpinData).includes('spinnerEnabled') && Object.keys(freeSpinData).includes('votesReceivedFromFirst4Spins') && freeSpinData.totalSpinsUsed < 4 ? <SpinerHeader /> : <GoldenSpinerHeader />}
              </>}
            </SpinDivBox>
            : freeSpinData?.freeSpinAvailable < 1 && voteNumber == 0 ?
              <SpinDivBox
                onClick={() => {
                  if (!showMenubar) {
                    handleSoundClick();
                    navigate("/wheel");
                  }
                }}
              >
                {<>
                  {(megaSpinData?.megaSpinAvailable == 1 || voteNumber == 0) &&
                    Object.keys(freeSpinData).includes('spinnerEnabled') && Object.keys(freeSpinData).includes('votesReceivedFromFirst4Spins') && freeSpinData.totalSpinsUsed < 4 ? <SpinerHeader /> : <GoldenSpinerHeader />
                  }
                </>}
              </SpinDivBox>
              :
              <SpinDivBox
                onClick={() => {
                  if (!showMenubar) {
                    handleSoundClick();
                    if (megaSpinData?.megaSpinAvailable > 0 || (megaSpinData?.megaSpinAvailable < 1 && (freeSpinData?.freeSpinAvailable > 0 || silverSpinData?.silverSpinAvailable > 0))) {
                      navigate("/wheel");
                    }

                  }

                }}
              >
                {silverSpinData?.silverSpinAvailable > 0 ? <SpinerHeader /> :
                  userInfo?.voteValue >= spinAccessLimit ? <GoldenSpinerHeader /> : <>
                    {Object.keys(freeSpinData).includes('spinnerEnabled') && Object.keys(freeSpinData).includes('votesReceivedFromFirst4Spins') && freeSpinData.totalSpinsUsed < 4
                      ? <SpinerHeader />
                      : megaSpinData?.megaSpinAvailable > 0 ?
                        <GoldenSpinerHeader /> : freeSpinData?.freeSpinAvailable > 0 && megaSpinData?.megaSpinAvailable < 1 && <SpinerHeader />}
                  </>}
              </SpinDivBox>}

          {userInfo?.uid && freeSpinData?.freeSpinAvailable < 1 && <Countdown date={contDownValue}
            renderer={({ hours, minutes, seconds, completed }) => {
              if (completed) {
                console.log("completedcompletedcompleted")
                getSpinData(userInfo?.uid)
              }
              return (
                <>
                </>
              );

            }}
          />}
        </div>
      </HeaderCenter>
      <div
        className="scroll-circle-progress"
        style={{
          cursor: "pointer",
          borderRadius: "50%",
          border: "1px solid #160133",
          position: "absolute",
          top: "-3px",
          right: `${window.screen.width > 767 ? "-10px" : "0px"}`,
          zIndex: 1000,

        }}
        onClick={() => {
          navigate("/profile/mine");
        }}
      >
        <HeaderProgressbar
          percentage={Number(cpmValueShow?.toFixed(3) || 0)}
          remainingReward={remainingReward}
        />
      </div>
    </div>
  )
}

export default memo(HeaderScroll)
